@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-organization-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [organization]="_context.formContext.item"
                (organizationUpdated)="onOrganizationUpdated($event)"
                (canceled)="onCanceled($event)"></app-organization-form>
        </mat-tab>
        @if (!!_paramsContext?.paramsValues) {
            <mat-tab label="Paramètres">
                <app-parameters-values-form
                    [disabled]="_context.formMode === FormMode.Reading"
                    [context]="_paramsContext"
                    [paramsValues]="_paramsContext.paramsValues"
                    [hierarchyValues]="_paramsContext.groupParentParamsValues"
                    (paramsValuesUpdated)="onParamsValuesUpdated($event)"
                    (paramsExported)="onParamsExported()"
                    (canceled)="onCanceled($event)"></app-parameters-values-form>
            </mat-tab>
        }
    </mat-tab-group>
}
